// ** Routes Imports

import AnnounceRoutes from './router/Announce';
import AnnounceTypeRoutes from './router/AnnounceType';
import AreaRoutes from './router/Area';
import BusinessRoutes from './router/Business';
import BusinessTypeRoutes from './router/BusinessType';
import BusinessUserRoutes from './router/BusinessUser';
import CalendarRoutes from './router/Calendar';
import CommissionRoutes from './router/Commission';
import CompanyRoutes from './router/Company';
import ComponentDivideRoutes from './router/ComponentDivide';
import ComponentGroupRoutes from './router/ComponentGroup';
import ComponentRoutes from './router/Component';
import CouponRoutes from './router/Coupon';
import CustomerRoutes from './router/CustomerPage';
import CustomerTypeRoutes from './router/CustomerType';
import DashboardRoutes from './router/Dashboards';
import DateCofirmTimeKeepingRoutes from './router/DateConfirmTimeKeeping';
import DebitRoutes from './router/Debit';
import DegreeRoutes from './router/Degree';
import DepartmentRoutes from './router/Department';
import ExpendTypeRoutes from './router/ExpendType';
import FunctionGroupRoutes from './router/FunctionGroup';
import FunctionsRoutes from './router/Functions';
import GrossProfitReportRoutes from './router/GrossProfitReport';
import HolidayRoutes from './router/Holiday';
import HrSalaryRoutes from './router/HrSalary';
import MailRoutes from './router/Mail';
import ManufacturerRoutes from './router/Manufacturer';
import MenusRoutes from './router/Menus';
import NewsInsideRoutes from './router/NewsInside';
import NewsRoutes from './router/News';
import OffWorkReviewLevelRoutes from './router/OffWorkReviewLevel';
import OffWorkRoutes from './router/OffWork';
import OffWorkTypeRoutes from './router/OffWorkType';
import OldProductPriceRoutes from './router/OldProductPrice';
import OrdersRoutes from './router/Orders';
import OrderStatusRoutes from './router/OrderStatus';
import OrderTypeRoutes from './router/OrderType';
import OutputTypeRoutes from './router/OutputType';
import PaymentSlipRoutes from './router/PaymentSlip';
import PerformanceReportRoutes from './router/PerformanceReport';
import PermissionsRoutes from './router/Permissions';
import PositionLeverRoutes from './router/PositionLever';
import PositionRoutes from './router/Position';
import PriceReviewLevelRoutes from './router/PriceReviewLevel';
import PricesRoutes from './router/Prices';
import ProcessStepRoutes from './router/ProcessStep';
import ProductAttributeRoutes from './router/ProductAttribute';
import ProductCategoryRoutes from './router/ProductCategory';
import ProductModelRoutes from './router/ProductModel';
import ProductRoutes from './router/Product';
import ReceiveSlipRoutes from './router/ReceiveSlip';
import ReceiveTypeRoutes from './router/ReceiveType';
import ReportComponentRoutes from './router/ReportComponent';
import ReportInventory from './router/ReportStockInventory';
import ReportTaskRoutes from './router/ReportTask';
import RequestTypeRoutes from './router/RequestType';
import RequestWarrantyRepairRoutes from './router/RequestWarrantyRepair';
import RpRevenueRoutes from './router/RpRevenue';
import RsErrorGroupRoutes from './router/RsErrorGroup';
import RsErrorRoutes from './router/RsError';
import RsProStatusGroupRoutes from './router/RsProStatusGroup';
import RsProStatusRoutes from './router/RsProStatus';
import SettingPageRoutes from './router/Setting';
import ShiftRoutes from './router/Shift';
import SkillGroupRoutes from './router/SkillGroup';
import SkillLevelRoutes from './router/SkillLevel';
import SkillRoutes from './router/Skill';
import SolutionGroupRoutes from './router/SolutionGroup';
import SolutionRoutes from './router/Solution';
import StocksDetailRoutes from './router/StocksDetail';
import StocksInRequestRoutes from './router/StocksInRequest';
import StocksInTypeRoutes from './router/StocksInType';
import StocksOutRequestRoutes from './router/StocksOutRequest';
import StocksOutTypeRoutes from './router/StocksOutType';
import StocksReviewLevelRoutes from './router/StocksReviewLevel';
import StocksRoutes from './router/Stocks';
import StocksTakeRequestRoutes from './router/StocksTakeRequest';
import StocksTakeTypeRoutes from './router/StocksTakeType';
import StocksTransferRoutes from './router/StocksTransfer';
import StocksTransferTypeRoutes from './router/StocksTransferType';
import StocksTypeRoutes from './router/StocksType';
import StoreRoutes from './router/Store';
import SupplierRoutes from './router/Supplier';
import TimekeepingRoutes from './router/Timekeeping';
import UnitRoutes from './router/Unit';
import UserGroupsRoutes from './router/UserGroups';
import UserLevelHistoryRoutes from './router/UserLevelHistory';
import UserScheduleRoutes from './router/UserSchedule';
import UsersRoutes from './router/Users';
import Page500 from 'pages/PageError/Page500';
import Page404 from 'pages/PageError/Page404';
import WarrantyInformationRoutes from './router/WarrantyInformation';
import RequestWarrantyStocksInRoutes from './router/RequestWarrantyStocksIn';
// import Page500 from 'pages/PageError/Page500';
import PurchaseRequisitionRoutes from './router/PurchaseRequisition';
import RequestPurchaseRoutes from './router/RequestPurchase';
//report warranty repair
import ReportWarrantyRepairRoutes from './router/ReportWarrantyRepair';
//report warranty repair
import CostTypeRoutes from './router/CostType';
import ProductSold from './router/ProductSold';
import RepairCompanyRoutes from './router/RepairCompany';
import WarrantyPeriodRoutes from './router/WarrantyPeriod';

const otherPages = [
  {
    path: '/404',
    exact: true,
    name: 'Trang không tồn tại',
    component: Page404,
  },
  {
    path: '/500/:error',
    exact: true,
    name: 'Không có quyền truy cập',
    component: Page500,
  },
];

const routes = [
  ...AnnounceRoutes,
  ...AnnounceTypeRoutes,
  ...AreaRoutes,
  ...BusinessRoutes,
  ...BusinessTypeRoutes,
  ...BusinessUserRoutes,
  ...CalendarRoutes,
  ...CommissionRoutes,
  ...CompanyRoutes,
  ...ComponentDivideRoutes,
  ...ComponentGroupRoutes,
  ...ComponentRoutes,
  ...CouponRoutes,
  ...CustomerRoutes,
  ...CustomerTypeRoutes,
  ...DashboardRoutes,
  ...DateCofirmTimeKeepingRoutes,
  ...DebitRoutes,
  ...DegreeRoutes,
  ...DepartmentRoutes,
  ...ExpendTypeRoutes,
  ...FunctionGroupRoutes,
  ...FunctionsRoutes,
  ...HolidayRoutes,
  ...HrSalaryRoutes,
  ...MailRoutes,
  ...ManufacturerRoutes,
  ...MenusRoutes,
  ...NewsInsideRoutes,
  ...NewsRoutes,
  ...OffWorkReviewLevelRoutes,
  ...OffWorkRoutes,
  ...OffWorkTypeRoutes,
  ...OldProductPriceRoutes,
  ...OrdersRoutes,
  ...OrderStatusRoutes,
  ...OrderTypeRoutes,
  ...OutputTypeRoutes,
  ...PaymentSlipRoutes,
  ...PerformanceReportRoutes,
  ...PermissionsRoutes,
  ...PositionLeverRoutes,
  ...PositionRoutes,
  ...PriceReviewLevelRoutes,
  ...PricesRoutes,
  ...ProcessStepRoutes,
  ...ProductAttributeRoutes,
  ...ProductCategoryRoutes,
  ...ProductModelRoutes,
  ...ProductRoutes,
  ...ReceiveSlipRoutes,
  ...ReceiveTypeRoutes,
  ...ReportInventory,
  ...ReportTaskRoutes,
  ...RequestTypeRoutes,
  ...RequestWarrantyRepairRoutes,
  ...RpRevenueRoutes,
  ...RsErrorGroupRoutes,
  ...RsErrorRoutes,
  ...RsProStatusGroupRoutes,
  ...RsProStatusRoutes,
  ...SettingPageRoutes,
  ...ShiftRoutes,
  ...SkillGroupRoutes,
  ...SkillLevelRoutes,
  ...SkillRoutes,
  ...SolutionGroupRoutes,
  ...SolutionRoutes,
  ...StocksDetailRoutes,
  ...StocksInRequestRoutes,
  ...StocksInTypeRoutes,
  ...StocksOutRequestRoutes,
  ...StocksOutTypeRoutes,
  ...StocksReviewLevelRoutes,
  ...StocksRoutes,
  ...StocksTakeRequestRoutes,
  ...StocksTakeTypeRoutes,
  ...StocksTransferRoutes,
  ...StocksTransferTypeRoutes,
  ...StocksTypeRoutes,
  ...StoreRoutes,
  ...SupplierRoutes,
  ...TimekeepingRoutes,
  ...UnitRoutes,
  ...UserGroupsRoutes,
  ...UserLevelHistoryRoutes,
  ...UserScheduleRoutes,
  ...UsersRoutes,
  ...WarrantyInformationRoutes,
  ...RequestWarrantyStocksInRoutes,
  ...otherPages,
  ...PerformanceReportRoutes,
  ...RpRevenueRoutes,
  ...PurchaseRequisitionRoutes,
  ...ReportComponentRoutes,
  ...GrossProfitReportRoutes,
  ...RequestPurchaseRoutes,
  ...ReportWarrantyRepairRoutes,
  ...CostTypeRoutes,
  ...ProductSold,
  ...RepairCompanyRoutes,
  ...WarrantyPeriodRoutes
];
export default routes;
